/*export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/page2",
    name: "Page 2",
    slug: "page2",
    icon: "FileIcon",
  },
]
*/

// import layout from "@/services/layoutService"

// export default layout.menuItems()

export default [
  {
    name: "ENGLAND",
    icon: "flag-icon-gb",
    iconPack: "flag-icons",
    class: 'group-gb',
    submenu: [{
        url: '/result/gb',
        name: 'Lotto Result',
        slug: 'admin-england-results'
      },
      {
        url: '/result/gb/add',
        name: 'Add Round',
        slug: 'admin-add-england'
      }
    ]
  },
  {
    name: "GERMANY",
    icon: "flag-icon-de",
    iconPack: "flag-icons",
    class: 'group-de',
    submenu: [{
        url: '/result/de',
        name: 'Lotto Result',
        slug: 'admin-germany-results'
      },
      {
        url: '/result/de/add',
        name: 'Add Round',
        slug: 'admin-add-germany'
      }
    ]
  },
  {
    name: "RUSSIA",
    icon: "flag-icon-ru",
    iconPack: "flag-icons",
    class: 'group-ru',
    submenu: [{
        url: '/result/ru',
        name: 'Lotto Result',
        slug: 'admin-russia-results'
      },
      {
        url: '/result/ru/add',
        name: 'Add Round',
        slug: 'admin-add-russia'
      }
    ]
  }
]
